import React, { useEffect, useState } from "react";
import { fetchManufacturing } from "@/lib/api";
import { PageHero, Section } from "@/components/Section";
import { Factory, Flame, Hammer, ShieldCheck, Sparkles, Wrench } from "lucide-react";

const STEPS = [
  { Icon: Factory, t: "Material Selection", d: "Chrome-vanadium steel billets sourced from verified mills, batch-traceable." },
  { Icon: Flame, t: "Forging", d: "Drop-forging presses shape each tool while the steel is at peak plasticity." },
  { Icon: Hammer, t: "Heat Treatment", d: "Hardening + tempering cycles deliver IS 2028/2029 mechanical properties." },
  { Icon: Sparkles, t: "Finishing & Plating", d: "Polishing, vibratory drums and chrome electroplating for a clean, corrosion-resistant finish." },
  { Icon: ShieldCheck, t: "Quality Control", d: "100% tools dimensionally inspected; torque & load-tested batches." },
  { Icon: Wrench, t: "Packing & Despatch", d: "Branded retail packs, OEM packs, export-ready cartons." },
];

const Manufacturing = () => {
  const [m, setM] = useState(null);
  useEffect(() => { fetchManufacturing().then(setM); }, []);

  return (
    <>
      <PageHero
        eyebrow="Inside the Factory"
        title={m?.heading || "Our Manufacturing Unit"}
        intro="Forging, heat-treatment, finishing and QC — all in one facility in India."
        breadcrumbs={<>Home / <span className="text-white">Manufacturing</span></>}
      />
      <Section>
        {m?.content ? (
          <div className="jt-prose max-w-3xl" data-testid="mfg-content">{m.content.split(/\n+/).filter(Boolean).map((line, i) => <p key={i}>{line}</p>)}</div>
        ) : null}
      </Section>
      <Section className="!pt-0">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--jt-border)] border border-[var(--jt-border)]" data-testid="mfg-steps">
          {STEPS.map((s, i) => (
            <div key={s.t} className="bg-white p-8">
              <div className="font-mono text-xs tracking-widest text-[var(--jt-primary)]">STEP&nbsp;·&nbsp;{String(i + 1).padStart(2, "0")}</div>
              <s.Icon className="w-8 h-8 mt-3 text-[var(--jt-ink)]" strokeWidth={1.5} />
              <h3 className="mt-3 font-display font-bold uppercase text-xl tracking-tight">{s.t}</h3>
              <p className="mt-2 text-sm text-[var(--jt-text-muted)] leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
};

export default Manufacturing;
